import { Status } from '../../helpers/statusHelpers';
import { Icon } from '../icon/Icon';
import { Icons } from '../icon/icons/material';
import styles from './StatusHeader.module.scss';

export const StatusHeader = ({ headline, status, icon }: { headline: string; status?: Status; icon?: Icons; }) => {
    return <div className={styles['status-header']}>
        {status && <label className="df-status-label" data-status={status} />}
        <b>{headline}</b>
        {icon && <Icon.Base iconName={icon} title='' />}
    </div>;
};

export default StatusHeader;